jQuery(document).ready(function () {

  // console.log('success');

  const beforeLabel = jQuery('.elder-family .twentytwenty-container .twentytwenty-handle .twentytwenty-left-arrow');

  if (jQuery(".elder-family").length) {
    beforeLabel.html('<span class="label-text">ELDER</span>');
    // alert(beforeLabel.text());
  }
  const afterLabel = jQuery('.elder-family .twentytwenty-container .twentytwenty-handle .twentytwenty-right-arrow');

  if (jQuery(".elder-family").length) {
    afterLabel.html('<span class="label-text">FAMILY</span>');
    // alert(afterLabel.text());
  }


  // feature row cards equal height
  function equalHeight() {
    var maxHeight = 0;

    jQuery('.feature-row .vc_custom_heading_wrap').css('height', 'auto'); // reset

    jQuery('.feature-row .vc_custom_heading_wrap').each(function () {
      var h = jQuery(this).outerHeight();
      if (h > maxHeight) {
        maxHeight = h;
      }
    });

    jQuery('.feature-row .vc_custom_heading_wrap').height(maxHeight);
  }

  equalHeight();

  // Recalculate on resize
  jQuery(window).resize(function () {
    equalHeight();
  });


});

jQuery(document).on('nfFormSubmitResponse', function (e, response) {

  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: 'ninja_form_submit',
    ninjaFormId: response.id,
    ninjaFormTitle: response?.response?.data?.settings?.title || '',
    pageTitle: document.title,
  });

});

// news and stories redirect to new page

jQuery(document).ready(function () {
  jQuery('.news-and-stories-body .owl-carousel a').attr({
    target: '_blank'
  });
});

// investors redirect to new page

jQuery(document).ready(function () {
  jQuery('.page-id-173195 .isotope-system a').attr({
    target: '_blank'
  });
});